function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1968(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30.69,
    height: 15.66,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9211764705882353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 7.83,
    fontFamily: "Arial"
  }, "\n        Lake_of_the_Woods\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15.66,
    width: 30.69,
    height: 17.38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 24.35,
    fontFamily: "Arial"
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.03,
    width: 30.69,
    height: 23.3,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 44.68,
    fontFamily: "Arial"
  }, "\n        Red_Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 56.33,
    width: 30.69,
    height: 26.18,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 69.42,
    fontFamily: "Arial"
  }, "\n        Mahnomen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 82.51,
    width: 30.69,
    height: 30.99,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.83625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 98.00500000000001,
    fontFamily: "Arial"
  }, "\n        Traverse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 113.5,
    width: 30.69,
    height: 35.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.384285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 131.155,
    fontFamily: "Arial"
  }, "\n        Kittson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 148.81,
    width: 30.69,
    height: 35.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.069
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 166.705,
    fontFamily: "Arial"
  }, "\n        Clearwater\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 184.6,
    width: 30.69,
    height: 39.66,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 204.43,
    fontFamily: "Arial"
  }, "\n        Big_Stone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 224.25,
    width: 30.69,
    height: 40.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.384285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 244.5,
    fontFamily: "Arial"
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 264.75,
    width: 30.69,
    height: 41.15,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.138
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 285.325,
    fontFamily: "Arial"
  }, "\n        Grant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 305.91,
    width: 30.69,
    height: 41.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 326.84000000000003,
    fontFamily: "Arial"
  }, "\n        Wilkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 347.76,
    width: 30.69,
    height: 42.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.384285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 369.105,
    fontFamily: "Arial"
  }, "\n        Kanabec\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 390.46,
    width: 30.69,
    height: 49.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.384285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 415.335,
    fontFamily: "Arial"
  }, "\n        Hubbard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 440.2,
    width: 30.69,
    height: 50.37,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 465.385,
    fontFamily: "Arial"
  }, "\n        Norman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 490.57,
    width: 30.69,
    height: 50.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 515.87,
    fontFamily: "Arial"
  }, "\n        Roseau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 541.17,
    width: 30.69,
    height: 50.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.384285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 566.6049999999999,
    fontFamily: "Arial"
  }, "\n        Stevens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 592.04,
    width: 30.69,
    height: 53.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.6725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 619.015,
    fontFamily: "Arial"
  }, "\n        Pope\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 645.99,
    width: 30.69,
    height: 54.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.6725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.345,
    y: 672.995,
    fontFamily: "Arial"
  }, "\n        Rock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 0,
    width: 39.62,
    height: 41.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.603333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.5,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Wadena\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.31,
    y: 0,
    width: 40.2,
    height: 41.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.0200000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 90.41,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Pennington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.51,
    y: 0,
    width: 41.61,
    height: 41.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.315,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Aitkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.13,
    y: 0,
    width: 42,
    height: 41.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.386
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 173.13,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.12,
    y: 0,
    width: 42.21,
    height: 41.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.658888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.225,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Pipestone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.33,
    y: 0,
    width: 42.87,
    height: 41.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2253846153846153
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 257.765,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Lac_qui_Parle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.2,
    y: 0,
    width: 43.31,
    height: 41.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.988333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 300.855,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.51,
    y: 0,
    width: 43.33,
    height: 41.93,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.4825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 344.175,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.85,
    y: 0,
    width: 43.81,
    height: 41.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.24125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 387.755,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Marshall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.66,
    y: 0,
    width: 46.61,
    height: 41.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.988333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.96500000000003,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Isanti\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.27,
    y: 0,
    width: 47.32,
    height: 41.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.24125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 479.93,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Watonwan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.6,
    y: 0,
    width: 47.45,
    height: 41.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.386
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 527.325,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Swift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.05,
    y: 0,
    width: 48.5,
    height: 41.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.658888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.3,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Sherburne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.55,
    y: 0,
    width: 49.77,
    height: 41.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 624.435,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 649.32,
    y: 0,
    width: 50.68,
    height: 41.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.193
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.6600000000001,
    y: 20.965,
    fontFamily: "Arial"
  }, "\n        Mille_Lacs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 41.93,
    width: 50.49,
    height: 43.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8753333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.935,
    y: 63.495000000000005,
    fontFamily: "Arial"
  }, "\n        Yellow_Medicine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 85.07,
    width: 50.49,
    height: 43.48,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9527272727272726
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.935,
    y: 106.80999999999999,
    fontFamily: "Arial"
  }, "\n        Koochiching\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 128.54,
    width: 50.49,
    height: 43.48,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.935,
    y: 150.28,
    fontFamily: "Arial"
  }, "\n        Pine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 172.02,
    width: 50.49,
    height: 43.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.4575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.935,
    y: 193.85000000000002,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 215.69,
    width: 50.49,
    height: 43.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.935,
    y: 237.545,
    fontFamily: "Arial"
  }, "\n        Sibley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 259.4,
    width: 50.49,
    height: 45.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.516
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.935,
    y: 281.97999999999996,
    fontFamily: "Arial"
  }, "\n        Cottonwood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 304.55,
    width: 50.49,
    height: 46.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.743333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.935,
    y: 327.78000000000003,
    fontFamily: "Arial"
  }, "\n        Waseca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 351.01,
    width: 50.49,
    height: 46.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.677142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.935,
    y: 374.38,
    fontFamily: "Arial"
  }, "\n        Chisago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 397.76,
    width: 50.49,
    height: 46.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.704285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.935,
    y: 421.22499999999997,
    fontFamily: "Arial"
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 444.68,
    width: 50.49,
    height: 48.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.882857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.935,
    y: 468.77,
    fontFamily: "Arial"
  }, "\n        Wabasha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 492.86,
    width: 50.49,
    height: 48.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.1425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.935,
    y: 517.145,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 541.43,
    width: 50.49,
    height: 48.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.161666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.935,
    y: 565.915,
    fontFamily: "Arial"
  }, "\n        Benton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 590.41,
    width: 50.49,
    height: 53.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.415000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.935,
    y: 617,
    fontFamily: "Arial"
  }, "\n        Meeker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 643.58,
    width: 50.49,
    height: 56.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.31125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.935,
    y: 671.7900000000001,
    fontFamily: "Arial"
  }, "\n        Nicollet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.18,
    y: 41.93,
    width: 52.28,
    height: 54.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.468571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.32000000000001,
    y: 69.32,
    fontFamily: "Arial"
  }, "\n        Redwood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.47,
    y: 41.93,
    width: 53.27,
    height: 54.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.3175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.105,
    y: 69.32,
    fontFamily: "Arial"
  }, "\n        Todd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.74,
    y: 41.93,
    width: 53.86,
    height: 54.78,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.7325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.67000000000002,
    y: 69.32,
    fontFamily: "Arial"
  }, "\n        Beltrami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.59,
    y: 41.93,
    width: 53.95,
    height: 54.78,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.74375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.565,
    y: 69.32,
    fontFamily: "Arial"
  }, "\n        Le_Sueur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.54,
    y: 41.93,
    width: 55.78,
    height: 54.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.8475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322.43,
    y: 69.32,
    fontFamily: "Arial"
  }, "\n        Renville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.32,
    y: 41.93,
    width: 56.12,
    height: 54.78,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.695
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 378.38,
    y: 69.32,
    fontFamily: "Arial"
  }, "\n        Lyon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.44,
    y: 41.93,
    width: 56.91,
    height: 54.78,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.895,
    y: 69.32,
    fontFamily: "Arial"
  }, "\n        Nobles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.35,
    y: 41.93,
    width: 57.41,
    height: 54.78,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 492.055,
    y: 69.32,
    fontFamily: "Arial"
  }, "\n        Becker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 520.77,
    y: 41.93,
    width: 58.47,
    height: 54.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.086666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.005,
    y: 69.32,
    fontFamily: "Arial"
  }, "\n        Faribault\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.24,
    y: 41.93,
    width: 59.73,
    height: 54.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.8475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.105,
    y: 69.32,
    fontFamily: "Arial"
  }, "\n        Fillmore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 638.97,
    y: 41.93,
    width: 61.03,
    height: 54.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.825714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.485,
    y: 69.32,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.18,
    y: 96.71,
    width: 62.72,
    height: 55.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.173333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.54,
    y: 124.22999999999999,
    fontFamily: "Arial"
  }, "\n        Steele\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.18,
    y: 151.75,
    width: 62.72,
    height: 55.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.54,
    y: 179.43,
    fontFamily: "Arial"
  }, "\n        Morrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.18,
    y: 207.11,
    width: 62.72,
    height: 57.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.656666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.54,
    y: 236.08,
    fontFamily: "Arial"
  }, "\n        Carver\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.18,
    y: 265.05,
    width: 62.72,
    height: 58.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.644
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.54,
    y: 294.16,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.18,
    y: 323.26,
    width: 62.72,
    height: 58.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.54,
    y: 352.705,
    fontFamily: "Arial"
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.18,
    y: 382.15,
    width: 62.72,
    height: 59.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.444285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.54,
    y: 411.705,
    fontFamily: "Arial"
  }, "\n        Carlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.18,
    y: 441.26,
    width: 62.72,
    height: 59.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.888333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.54,
    y: 470.925,
    fontFamily: "Arial"
  }, "\n        McLeod\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.18,
    y: 500.59,
    width: 62.72,
    height: 60.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.148
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.54,
    y: 530.9599999999999,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.18,
    y: 561.33,
    width: 62.72,
    height: 65.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9688888888888885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.54,
    y: 594.2800000000001,
    fontFamily: "Arial"
  }, "\n        Kandiyohi\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.18,
    y: 627.23,
    width: 62.72,
    height: 72.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9688888888888885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.54,
    y: 663.615,
    fontFamily: "Arial"
  }, "\n        Crow_Wing\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.9,
    y: 96.71,
    width: 65.4,
    height: 71.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.60000000000002,
    y: 132.48,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.3,
    y: 96.71,
    width: 66.05,
    height: 71.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.5125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.32500000000002,
    y: 132.48,
    fontFamily: "Arial"
  }, "\n        Rice\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.35,
    y: 96.71,
    width: 67.92,
    height: 71.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 309.31,
    y: 132.48,
    fontFamily: "Arial"
  }, "\n        Wright\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.28,
    y: 96.71,
    width: 68.83,
    height: 71.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.832857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.695,
    y: 132.48,
    fontFamily: "Arial"
  }, "\n        Goodhue\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.11,
    y: 96.71,
    width: 69.87,
    height: 71.54,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.645000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 447.045,
    y: 132.48,
    fontFamily: "Arial"
  }, "\n        Itasca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.98,
    y: 96.71,
    width: 71.4,
    height: 71.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 517.6800000000001,
    y: 132.48,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.38,
    y: 96.71,
    width: 71.41,
    height: 71.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.92625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 589.085,
    y: 132.48,
    fontFamily: "Arial"
  }, "\n        Freeborn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.79,
    y: 96.71,
    width: 75.21,
    height: 71.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.923333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.395,
    y: 132.48,
    fontFamily: "Arial"
  }, "\n        Winona\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.9,
    y: 168.26,
    width: 89.39,
    height: 67.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.447999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.595,
    y: 201.88,
    fontFamily: "Arial"
  }, "\n        Mower\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.9,
    y: 235.5,
    width: 89.39,
    height: 67.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.742
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.595,
    y: 269.21,
    fontFamily: "Arial"
  }, "\n        Blue_Earth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.9,
    y: 302.91,
    width: 89.39,
    height: 71.43,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.143000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.595,
    y: 338.625,
    fontFamily: "Arial"
  }, "\n        Otter_Tail\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.9,
    y: 374.35,
    width: 89.39,
    height: 99.91,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.939
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.595,
    y: 424.305,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.9,
    y: 474.26,
    width: 89.39,
    height: 109.87,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.595,
    y: 529.1949999999999,
    fontFamily: "Arial"
  }, "\n        Olmsted\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.9,
    y: 584.13,
    width: 89.39,
    height: 115.87,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.595,
    y: 642.065,
    fontFamily: "Arial"
  }, "\n        Stearns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.3,
    y: 168.26,
    width: 115.4,
    height: 133.4,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.233333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 291,
    y: 234.95999999999998,
    fontFamily: "Arial"
  }, "\n        Dakota\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.7,
    y: 168.26,
    width: 115.92,
    height: 133.4,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.184
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 406.65999999999997,
    y: 234.95999999999998,
    fontFamily: "Arial"
  }, "\n        Anoka\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.62,
    y: 168.26,
    width: 235.38,
    height: 133.4,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.127272727272727
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 582.31,
    y: 234.95999999999998,
    fontFamily: "Arial"
  }, "\n        Saint_Louis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.3,
    y: 301.66,
    width: 151.51,
    height: 398.34,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.251666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 309.055,
    y: 500.83000000000004,
    fontFamily: "Arial"
  }, "\n        Ramsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.81,
    y: 301.66,
    width: 315.19,
    height: 398.34,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.39875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 542.405,
    y: 500.83000000000004,
    fontFamily: "Arial"
  }, "\n        Hennepin\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1968);
export default __webpack_public_path__ + "static/media/1968.d665e01228ed2f28b306e5f00fe4e031.svg";
export { ForwardRef as ReactComponent };